
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Badge extends Vue {
  @Prop(String) readonly text!: string;
  @Prop(String) readonly color!: string;
  @Prop(String) readonly size!: string;

  get colorClass() {
    switch (this.color) {
      case "red":
        return "bg-red-100 text-red-800 border-red-100";
      case "orange":
        return "bg-orange-100 text-orange-800 border-orange-100";
      case "yellow":
        return "bg-yellow-100 text-yellow-800 border-yellow-100";
      case "green":
        return "bg-green-100 text-green-800 border-green-100";
      case "teal":
        return "bg-teal-100 text-teal-800 border-teal-100";
      case "blue":
        return "bg-blue-100 text-blue-800 border-blue-100";
      case "indigo":
        return "bg-indigo-100 text-indigo-800 border-indigo-100";
      case "purple":
        return "bg-purple-100 text-purple-800 border-purple-100";
      case "pink":
        return "bg-pink-100 text-pink-800 border-pink-100";
      default:
        return "bg-gray-50 text-gray-800 border-gray-50";
    }
  }

  get sizeClass() {
    switch (this.size) {
      case "xs":
        return "px-2.5 py-0.5 text-xs font-bold leading-4";
      default:
        return "px-3 py-0.5 text-xs font-bold leading-5";
    }
  }
}
